<template>
  <div>
    <Alert class="success" icon="check">
      <p>
        If your account exists, an E-mail will be sent to your e-mail account.
      </p>
      <p>
        Please check your E-mail for further instructions.
      </p>
    </Alert>
    <Divider />
    <Alert class="info" icon="info">
      <p>
        <strong
          >If you can't find the E-mail in your Inbox, please check your spam
          folder.</strong
        >
      </p>
    </Alert>
  </div>
</template>

<script>
export default {
  name: "auth-password-remind-success"
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
